import { render, staticRenderFns } from "./main_link_button.vue?vue&type=template&id=1e6b2419&"
import script from "./main_link_button.vue?vue&type=script&lang=js&"
export * from "./main_link_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports